export default __webpack_public_path__ + "static/Tip-4-Choose-a-window-seat-849452d9c0423ccbab15bc32ce0a1e99.jpg";